import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { map } from "lodash-es";
import { useTranslation } from "react-i18next";

import {
  selectPanelsByLayerGroup,
  selectCurrentLayerGroup,
} from "@/selector";
import { actionCreators } from "@/duck/dashboard";
import "@/components/dashboard/PanelSwitch.less";

const PanelSwitch = () => {
  const { t, i18n } = useTranslation();

  const panels = useSelector(selectPanelsByLayerGroup);
  const currentLayerGroup = useSelector(selectCurrentLayerGroup);
  const dispatch = useDispatch();
  const switchPanel = useCallback(
    (panelName) => {
      dispatch(
        actionCreators.dashboard.panel.toggle({
          layerGroup: currentLayerGroup,
          name: panelName,
        })
      );
    },
    [dispatch, currentLayerGroup]
  );

  const changeLanguage = useCallback(
    (lng) => {
      i18n.changeLanguage(lng);
    },
    [i18n]
  );

  const switchLayer = useCallback(
    (panelName) => {
      dispatch(
        actionCreators.dashboard.panel.toggle({
          layerGroup: currentLayerGroup,
          name: panelName,
        })
      );
    },
    [dispatch, currentLayerGroup]
  );

  const panelElments = map(panels, (value, key) => {
    if (key === "indicator") {
      return (
        <div
          key={`panel-switcher-${key}`}
          className={value ? "item active" : "item"}
          onClick={() => switchPanel(key)}
        >
          {t(`switcher.${key}`)}
        </div>
      );
    } else if (key === "risk") {
      return (
        <div
          key={`panel-switcher-${key}`}
          className={value ? "item active" : "item"}
          onClick={() => switchLayer("risk")}
        >
          {t(`switcher.${key}`)}
        </div>
      );
    } else if (key === "buffer") {
      return (
        <div
          key={`panel-switcher-${key}`}
          className={value ? "item active" : "item"}
          onClick={() => switchLayer("buffer")}
        >
          {t(`switcher.${key}`)}
        </div>
      );
    } else {
      return (
        <div
          key={`panel-switcher-${key}`}
          className={value ? "item active" : "item"}
          onClick={() => switchPanel(key)}
        >
          {t(`switcher.${key}`)}
        </div>
      );
    }
  });

  return (
    <div className="panel-switch">
      {panelElments}
      <div
        key={`panel-switcher-index`}
        className="item active"
        style={{ marginLeft: 20 }}
        onClick={() =>
          (window.location.href =
            "http://arcticroute.tpdc.ac.cn/channel/browser")
        }
      >
        {t("index")}
      </div>
      {i18n.language === "zh" ? (
        <div
          key={`panel-switcher-lang`}
          className="item active"
          style={{ marginLeft: 20 }}
          onClick={(e) => changeLanguage("en")}
        >
          English
        </div>
      ) : (
        <div
          key={`panel-switcher-lang`}
          className="item active"
          style={{ marginLeft: 20 }}
          onClick={(e) => changeLanguage("zh")}
        >
          中文
        </div>
      )}
    </div>
  );
};

export default PanelSwitch;
